import type { IApiGetOrganizationUserResponseBody } from '~/lib/api/modules/Organizations';

export type IOrganizationUserFilter = {
  includeIds?: Array<string>;
  excludeIds?: Array<string>;
};

export const organizationUserFilterPredicate = (
  organizationUser: IApiGetOrganizationUserResponseBody,
  filter: IOrganizationUserFilter,
): boolean => {
  const isIdIncluded =
    filter.includeIds?.includes(organizationUser._id) ?? true;
  const isIdExcluded =
    filter.excludeIds?.includes(organizationUser._id) ?? false;

  return isIdIncluded && !isIdExcluded;
};
